<template>
    <v-container grid-list-md fluid class="pb-0 mb-0">
        <v-card class="default_card large mx-0 my-2 pa-2 fill-height sticky-card" elevation="0">
            <v-row no-gutters>
                <v-col cols="8">
                    <v-btn-back @click.stop="$router.go(-1)"> </v-btn-back>
                    <!-- <span class="headline">
                        {{exportName.length ? exportName : "Export office " + format}}
                    </span> -->
                </v-col>
                <v-spacer> </v-spacer>
                <v-col cols="2" class="d-flex align-center justify-end">
                    <v-btn rounded="pill" block :disabled="isDisabled" @click="upload()">
                        {{ patternId ? "Modifier" : "Créer" }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-card>
        <v-card class="default_card_admin" v-if="profile.configuration.accountingRule.read">
            <v-row cols="8" class="mb-2">
                <v-col cols="12" class="d-flex justify-start align-center">
                    <h2>Nom de l'export</h2>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="12" class="title px-1">
                    <v-text-field-filled
                        placeholder="Nom"
                        :hide-details="true"
                        v-model="exportName"
                        outlined
                        density="compact"
                    />
                </v-col>
            </v-row>
            <template v-if="format === 'xlsx'">
                <v-row no-gutters class="mt-4 mb-2">
                    <v-col cols="12" class="d-flex justify-start align-center">
                        <h2>Exports</h2>
                    </v-col>
                </v-row>
                <template v-for="(exportItem, index) in exportList">
                    <v-row no-gutters class="py-1">
                        <v-col cols="12">
                            <v-checkbox
                                v-model="exportList[index].selected"
                                :label="exportItem.text"
                                density="compact"
                                hide-details
                            />
                        </v-col>
                    </v-row>
                    <v-row
                        v-if="exportList[index].selected"
                        no-gutters
                    >
                        <v-col cols="4" class="px-1">
                            <v-text-field-filled
                                v-model="
                                    exportList[index].position
                                        .worksheet
                                "
                                label="Nom de la feuille"
                                outlined
                                hide-details
                                density="compact"
                            />
                        </v-col>
                        <v-col cols="4" class="px-1">
                            <oss-text-field-filled
                                v-model="
                                    exportList[index].position
                                        .startRow
                                "
                                label="Ligne de départ"
                                hide-details
                            />
                        </v-col>
                        <v-col cols="4" class="px-1">
                            <v-text-field-filled
                                v-model="
                                    exportList[index].position
                                        .startColumn
                                "
                                label="Colonne de départ"
                                outlined
                                hide-details
                                density="compact"
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            class="py-2"
                            v-if="index !== exportList.length - 1"
                        >
                            <v-divider />
                        </v-col>
                    </v-row>
                </template>
                <v-row
                    no-gutters
                    class="d-flex justify-center pt-3"
                >
                    <v-col cols="12">
                        <v-divider />
                    </v-col>
                </v-row>
            </template>
            <v-row no-gutters class="my-2">
                <v-col cols="12" class="d-flex justify-start align-center">
                    <h2>Fichier</h2>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="12" class="title px-1 pt-2">
                    <v-text-field-filled
                        placeholder="Joindre un fichier"
                        :hide-details="true"
                        outlined
                        readonly
                        @click.stop="
                            !readonly
                                ? (dialogUploadDocument = true)
                                : ''
                        "
                        :model-value="filename"
                        density="compact"
                    />
                </v-col>
            </v-row>
        </v-card>
        <div>
            <ScopeManager
                v-model="scopeSync"
                v-model:id="scopeId"
                v-model:name="scopeName"
                :readonly="readonly"
            />
            <v-snackbar v-model="snackbarActive">
                {{ snackbarText }}
                <template v-slot:actions>
                    <v-btn @click="snackbarActive = false" variant="text">
                        Close
                    </v-btn>
                </template>
            </v-snackbar>
        </div>
        <oss-dialog v-model="dialogUploadDocument" title="Importer un fichier">
            <div style="max-width: 70%">
                <UploadDocument
                    :showFirstPrevious="false"
                    :companyId="accountingCompanyId"
                    documentType="EXPORT_OFFICE"
                    :multiple="false"
                    :freeTag="false"
                    :showBtns="true"
                    :inExtensions="
                        format === 'xlsx' ? ['xlsx', 'xls', 'xlsm'] : ['docx', 'doc']
                    "
                    @file="addPersonalisedDoc($event)"
                />
            </div>
        </oss-dialog>
    </v-container>
</template>
<script lang="ts">
import gql from "graphql-tag";
import { User } from "../../store/store";
import { Apollo } from "@/decorators";

import ScopeManager from "../companyScope/ScopeManager.vue";
import UploadDocument from "../document/UploadDocuments.vue";

import UPSERT_EXPORT_OFFICE from "../../graphql/exportOffice/UpsertExportOffice.gql";
import EXPORT_OFFICE from "../../graphql/exportOffice/ExportOffice.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Model } from "vue-facing-decorator";
import { Ref } from "vue-facing-decorator";

@Component({
    components: {
        ScopeManager,
        UploadDocument,
    },
    emits: ["upserted"],
})
export class ExportOfficeSheet extends Vue {
    @Model({ type: String, name: "companyScope" }) scopeSync!: any;

    exportName = "";
    dialogUploadDocument = false;

    snackbarText = "";
    snackbarActive = false;

    validationForAllAccountingCompany = false;

    fileData = null;

    scopeName: string = "";
    scopeId_: string = "";

    get scopeId() {
        if (this.scopeSync?.id) {
            this.scopeId_ = this.scopeSync?.id;
        }
        return this.scopeId_;
    }

    set scopeId(value) {
        this.scopeId_ = value;
    }

    get accountingCompanyId() {
        return this.currentUser.company.id;
    }

    get isRootProfile() {
        if (this.currentUser.isRoot) {
            return true;
        }
        return false;
    }

    get patternId() {
        if (this.$route.params.id) {
            return this.$route.params.id;
        }
        return "";
    }

    get format() {
        if (this.$route.params.format) {
            return this.$route.params.format;
        } else if (this.fileData?.name) {
            const fileExtension = this.fileData.name.split(".").pop();
            const extension = ["xlsx", "xls", "xlsm"].includes(fileExtension) ? "xlsx" : "docx";
            return extension;
        }
        return "";
    }

    get filename() {
        debugger;
        if (this.fileData?.name) {
            return this.fileData.name;
        }
        return "";
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get profile() {
        return this.$store.state.user.profile;
    }

    get clientCompaniesIds() {
        const result = [];
        for (const company of this.currentUser.allAvailableCompanies) {
            result.push(company.id);
        }
        return result;
    }

    get isDisabled() {
        if (!this.fileData) {
            return true;
        }
        if (!this.exportName.length) {
            return true;
        }
        if (this.readonly) {
            return true;
        }
        if(!this.scopeId) {
            return true
        }
        return false;
    }

    get clientCompanies() {
        return this.currentUser.allAvailableCompanies.sort((a, b) => a.name.localeCompare(b.name));
    }

    readonlyTemporaire = false;
    scopeReadOnly = false;

    get readonly() {
        if (this.readonlyTemporaire) {
            return true;
        }
        if (!this.profile.configuration.accountingRule.write) {
            return true;
        }
        if (!this.scopeReadOnly) {
            return true
        }
        return false;
    }

    async addPersonalisedDoc(eventData = null) {
        debugger;
        if (eventData?.file?.fileKey) {
            this.fileData = eventData.file;
            this.dialogUploadDocument = false;
        }
        // const newFile = await this.$apollo.mutate({
        //     mutation: ADD_PERSONALISED_FILE,
        //     variables: {
        //         file: eventData.file,
        //         userId: this.currentUser.id,
        //         accountingCompanyId: this.accountingCompanyId,
        //         bookletTemplateId: this.bookletTemplateId,
        //         content: this.booklet
        //     }
        // })
    }

    async upload() {
        if (!this.isDisabled) {
            const result = await this.$apollo.mutate({
                mutation: UPSERT_EXPORT_OFFICE,
                variables: {
                    exportOfficeId: this.patternId,
                    companyScopeId: this.scopeId,
                    exports: this.exportList,
                    name: this.exportName,
                    file: this.fileData,
                    filename: this.filename,
                },
            });
            debugger;
            // this.$emit("upserted")
            this.$router.go(-1);
        }
    }

    @Apollo({
        query: EXPORT_OFFICE,
        variables() {
            return { id: this.patternId };
        },
        skip() {
            return this.patternId === null;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data.exportOffice) {
                    debugger;
                    for (const result of data.exportOffice.exports) {
                        for (const item of this.exportList) {
                            if (item.name === result.name) {
                                item.options = result.options;
                                item.position = result.position;
                                item.selected = true;
                            }
                        }
                    }
                    this.exportName = data.exportOffice.name;
                    this.fileData = data.exportOffice.file;
                    this.fileData.name = data.exportOffice.filename;
                    this.scopeId = data.exportOffice.companyScope.id;
                    this.scopeName = data.exportOffice.companyScope.name || "";
                    this.scopeReadOnly =  !(data.exportOffice.companyScope?.accountingCompanyOwner && 
                        data.exportOffice.companyScope?.accountingCompanyOwner.id === this.accountingCompanyId)
                    this.importSuccess = true;
                } else {
                    this.importSuccess = false;
                }
            }
        },
    })
    exportList = [
        {
            name: "balances",
            text: "Balances",
            options: {},
            position: {
                worksheet: "Custom Export",
                startRow: 1,
                startColumn: "A",
            },
            selected: false,
        },
        {
            name: "buildings",
            text: "Immeubles",
            options: {},
            position: {
                worksheet: "Custom Export",
                startRow: 1,
                startColumn: "A",
            },
            selected: false,
        },
        {
            name: "companyData",
            text: "Informations sur la société",
            options: {},
            position: {
                worksheet: "Custom Export",
                startRow: 1,
                startColumn: "A",
            },
            selected: false,
        },
    ];
    importSuccess: Boolean = false;
}

export default toNative(ExportOfficeSheet);
</script>
